import { render, staticRenderFns } from "./step.vue?vue&type=template&id=fb423924&scoped=true&"
import script from "./step.vue?vue&type=script&lang=ts&"
export * from "./step.vue?vue&type=script&lang=ts&"
import style0 from "./step.vue?vue&type=style&index=0&id=fb423924&lang=scss&scoped=true&"
import style1 from "./step.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb423924",
  null
  
)

export default component.exports